import { render, staticRenderFns } from "./SurgeryTime.vue?vue&type=template&id=b8ae0120&"
import script from "./SurgeryTime.vue?vue&type=script&lang=ts&"
export * from "./SurgeryTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ae0120')) {
      api.createRecord('b8ae0120', component.options)
    } else {
      api.reload('b8ae0120', component.options)
    }
    module.hot.accept("./SurgeryTime.vue?vue&type=template&id=b8ae0120&", function () {
      api.rerender('b8ae0120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/SurgeryTime.vue"
export default component.exports